<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{props ? `${$t("modal.commercial_config.ad_agency.edit")} ${props.name}` : $t("modal.commercial_config.ad_agency.create")}}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>
    
      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="code" id="code" autocomplete="off" :class="{'invalid': submitted && v$.model.code.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.commercial_config.ad_agency.code')" v-model="model.code" maxLength="255">
          <label for="code">{{$t("modal.commercial_config.ad_agency.code")}}
            <small v-if="submitted && v$.model.code.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="name" id="name" autocomplete="off" :class="{'invalid': submitted && v$.model.name.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.commercial_config.ad_agency.name')" v-model="model.name" maxLength="255">
          <label for="name">{{$t("modal.commercial_config.ad_agency.name")}}
            <small v-if="submitted && v$.model.name.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row component-modal__row__multiselect">
        <!-- <div class="component-modal-input component-modal-input--rename"> -->
          <label for="groupId">{{$t("modal.commercial_config.ad_agency.ad_agency_group")}}</label>
          <Multiselect
              v-model="model.adAgencyGroupId"
              :placeholder="$t('modal.placeholder_select') + $t('modal.commercial_config.ad_agency.ad_agency_group')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="false"
              :options="agencies" />

          <!-- <select name="groupId" id="groupId" v-model="model.adAgencyGroupId">
            <option :value="null">{{$t('modal.placeholder_select')}}{{$t("modal.commercial_config.ad_agency.ad_agency_group")}}</option>
            <option :value="agency.id" v-for="agency in agencies" :key="agency.id">{{agency.code}} - {{agency.name}}</option>
          </select> -->
        <!-- </div> -->
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="taxCode" id="taxCode" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.commercial_config.ad_agency.taxCode')" v-model="model.taxCode">
          <label for="taxCode">{{$t("modal.commercial_config.ad_agency.taxCode")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="address" id="address" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.commercial_config.ad_agency.address')" v-model="model.address">
          <label for="address">{{$t("modal.commercial_config.ad_agency.address")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="phone" id="phone" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.commercial_config.ad_agency.phone')" v-model="model.phone">
          <label for="phone">{{$t("modal.commercial_config.ad_agency.phone")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="contact" id="contact" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.commercial_config.ad_agency.contact')" v-model="model.contact">
          <label for="contact">{{$t("modal.commercial_config.ad_agency.contact")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="email" id="email" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.commercial_config.ad_agency.email')" v-model="model.email">
          <label for="email">{{$t("modal.commercial_config.ad_agency.email")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="comments" id="comments" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.commercial_config.ad_agency.comments')" v-model="model.comments">
          <label for="comments">{{$t("modal.commercial_config.ad_agency.comments")}}</label>
        </div>
      </div>
    
      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{ props ? $t("modal.save") : $t('modal.create') }}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{ $t("modal.cancel") }}
        </button>
      </div>

      <div class="component-modal__row" v-if="submitted && v$.model.$invalid">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          <span v-html="$t('modal.common.required_message', {inputs : v$.model.$silentErrors.map(error => $t(`modal.commercial_config.ad_agency.${error.$property == 'adAgencyGroupId' ? 'ad_agency_group' : error.$property}`)).join(', ') })"></span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { maxLength, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import Multiselect from '@vueform/multiselect';


export default {
  components: {
    Multiselect
  },
  setup() {
		const v$ = useVuelidate();
    const store = useStore();
    const props = computed(() => store.getters.modal_getProps);
    const agencies = computed(() => store.getters.adAgencyGroup_agenciesList);
    const submitted = ref(false);
    const model = ref({
      code: '',
      name: '',
      address: '',
      phone: '',
      taxCode: '',
      contact: '',
      email: '',
      comments: '',
      adAgencyGroupId: null
    });

    onMounted(async () => {
      if (props.value) model.value = Object.assign({}, props.value);
      await store.dispatch('adAgencyGroup_getAll');
    })

    async function closeModal() {
      await store.dispatch('modal_setActive');
      submitted.value = false;
    }

    async function saveAndClose() {
      submitted.value = true;
      if (!v$.value.model.$invalid) {
        try {
          await store.dispatch(props.value ? 'adAgency_update' : 'adAgency_create', model.value);
          this.closeModal();
        } catch (error) {
          console.error(error);
        }
      }
    }

    return {
      v$,
      props,
      model,
      submitted,
      agencies,
      saveAndClose,
      closeModal
    }
  },
	validations () {
    return {
      model: {
				code: {required, maxLengthValue: maxLength(255)},
				name: {required, maxLengthValue: maxLength(255)}
			}
    }
  }
};
</script>